import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "locale", "format", "handlePickerChange", "extraMessage", "value", "disableFuture", "disablePast", "onError"];
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { StyledDateField } from './dateStyles';
export var EmbersDateField = function EmbersDateField(_ref) {
  var theme = _ref.theme,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? moment.locale() : _ref$locale,
    format = _ref.format,
    handlePickerChange = _ref.handlePickerChange,
    extraMessage = _ref.extraMessage,
    value = _ref.value,
    disableFuture = _ref.disableFuture,
    disablePast = _ref.disablePast,
    onError = _ref.onError,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputText = _useState2[0],
    setInputText = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasError = _useState4[0],
    setHasError = _useState4[1];
  var intl = useIntl();
  var formatDate = function formatDate(value) {
    if (inputText.includes('.') || inputText.includes('-') || inputText.includes('/')) {
      var numFormat = moment.localeData(locale).longDateFormat('L');
      onValidate(moment(inputText, numFormat, true));
    } else {
      onValidate(moment(inputText, format, locale, true));
    }
  };
  useEffect(function () {
    setHasError(otherProps.color === 'error');
  }, [otherProps.color]);
  useEffect(function () {
    if (value) {
      if (value.isValid()) {
        var _value = value.format(format);
        if (inputText !== _value) {
          setInputText(_value);
          setHasError(false);
          onError === null || onError === void 0 || onError(false);
        }
      }
    } else {
      inputText && setInputText('');
    }
  }, [value]);
  var onValidate = function onValidate(date) {
    if (date.isValid()) {
      var today = moment();
      if (hasError) {
        setHasError(false);
        onError === null || onError === void 0 || onError(false);
      }

      // if the filled date is a disabled date, should force to the latest date
      if (disableFuture && date.isAfter(today) || disablePast && date.isBefore(today)) {
        setInputText(date.format(format));
        handlePickerChange === null || handlePickerChange === void 0 || handlePickerChange(date, true);
        setHasError(true);
        onError === null || onError === void 0 || onError(true);
      } else {
        setInputText(date.format(format));
        handlePickerChange === null || handlePickerChange === void 0 || handlePickerChange(date, false);
      }
    } else {
      handlePickerChange === null || handlePickerChange === void 0 || handlePickerChange(date, true);
      setHasError(true);
      onError === null || onError === void 0 || onError(true);
    }
  };
  var onChange = function onChange(e) {
    setHasError(false);
    onError === null || onError === void 0 || onError(false);
    setInputText(e.target.value.trim());
  };
  var onBlur = function onBlur(e) {
    e.preventDefault();
    var _value = (value === null || value === void 0 ? void 0 : value.format(format)) || '';
    if (_value !== inputText) {
      inputText ? formatDate(inputText) : handlePickerChange === null || handlePickerChange === void 0 ? void 0 : handlePickerChange(null, hasError);
    }
  };
  return /*#__PURE__*/React.createElement(StyledDateField, _extends({
    label: intl.formatMessage({
      id: 'embers.date.label',
      defaultMessage: 'Date'
    }),
    autoComplete: "off",
    value: inputText,
    onBlur: onBlur,
    onChange: onChange,
    extraMessage: hasError || otherProps.color === 'error' ? intl.formatMessage({
      id: 'embers.date.errorMessage',
      defaultMessage: 'Invalid date.'
    }) : extraMessage,
    color: hasError ? 'error' : ''
  }, otherProps));
};